module.exports = __webpack_public_path__ + "static/media/21ECLAC33.1e35034a.jpg";